export enum OverdueType {
  CUSTOM = 'CUSTOM',
  OVERDUE_NOT_PROCESSED = 'OVERDUE_NOT_PROCESSED',
  OVERDUE_PICKED = 'OVERDUE_PICKED',
  DUE_TODAY = 'DUE_TODAY',
  NOT_OVERDUE = 'NOT_OVERDUE',
  BLOCKED = 'BLOCKED'
}
